import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import Typography from '@material-ui/core/Typography';
import Button from '@material-ui/core/Button';
import IconButton from '@material-ui/core/IconButton';
import MenuIcon from '@material-ui/icons/Menu';
import AttachMoney from '@material-ui/icons/AttachMoney';
import logo from '../../assets/img/sonicleadgen.png';
import green from '@material-ui/core/colors/green';
//import PersistentDrawer from './RightSide'

const styles = theme => ({
  root: {
    flexGrow: 1,
    width: '100%'
  },
  flex: {
    flex: 1,
  },
  logo: {
    height: 50
  },
  menuButton: {
    marginLeft: -12,
    marginRight: 20,
  },
  leftIcon: {
    marginRight: theme.spacing.unit,
  },
  cssRoot: {
    color: '#FFFFFF',
    backgroundColor: green[500],
    '&:hover': {
      backgroundColor: green[700],
    }
  }
})

function ButtonAppBar(props) {
  const { classes } = props;
  return (
    <div className={classes.root}>
      <AppBar position="static" color="default">
        <Toolbar>
          <IconButton className={classes.menuButton} color="inherit" aria-label="Menu">
            <MenuIcon />
          </IconButton>
          <Typography variant="title" color="inherit" className={classes.flex}>
          <img src={logo} className={classes.logo}/>
          </Typography>
            {/* <Button
          variant="contained"
          color="primary"
          className={classes.cssRoot}
        >
     <AttachMoney className={classes.leftIcon} />
          Buy Leads
        </Button>*/}
  
        </Toolbar>
      </AppBar>
    </div>
  );
}

ButtonAppBar.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(ButtonAppBar);


// WEBPACK FOOTER //
// ./src/components/lib/Header.js